import { SortOrder } from 'antd/lib/table/interface'
import { ColumnsType } from 'antd/es/table'
import { TPageInfo, TQueryParams } from '../../components/Table/types'
import { ResponseWithPagination } from '../../constants'
import { Moment } from 'moment'
import { Dispatch, SetStateAction } from 'react'

export type UserContractCategoriesProps = {
  role?: string
  userId: string
  userName: string
  simpleViewModeOnly?: boolean
  canSeeExtendedViewMode?: boolean
}

export enum ReassignmentStatuses {
  PENDING = 'pending'
}

export enum ReassignmentTypes {
  REASSIGNMENT = 'reassignment',
  UNASSIGNMENT = 'unassignment'
}

export type ReassignmentData = {
  uuid: string
  effective_date: string
  type: ReassignmentTypes
  status: ReassignmentStatuses
}

export type UserContractCategory = {
  uuid: string
  name: string
  is_voting_panel_member?: boolean
  community_level: boolean | null
  community_level_disabled: boolean
  reassignment_request: ReassignmentData | null
}

export type TCCRelatedItemReassign = {
  effective_date?: string | Moment
  assignee?: string
  health_system_responsible_rfp?: string
  community_responsible_rfp?: string
  national_gpo_responsible_rfp?: string
  health_system_responsible_contract?: string
  community_responsible_contract?: string
  national_gpo_responsible_contract?: string
}

export type UserContractCategoriesParams = TQueryParams

export type UserContractCategoriesRequestData = {
  sortField?: keyof UserContractCategory
  sortOrder?: SortOrder
  page?: TPageInfo
  search?: string
}

export type UserContractCategoriesResponse =
  ResponseWithPagination<UserContractCategory>

export type ChangeCommunityLevelFunc = (
  ccId: string,
  name: string,
  value: boolean
) => Promise<void>

export type ChangeCommunityLevelRequest = {
  userId: string
  ccId: string
  data: {
    community_level: boolean
  }
}

export type UserContractCategoriesRequest = {
  uuid: string
  params?: UserContractCategoriesParams
}

export type TCCRelatedItem = {
  led_by: string
  can_be_edited?: boolean
}
export type TCCRelatedItems = {
  rfp: TCCRelatedItem[]
  contracts: TCCRelatedItem[]
}

export type CCRelatedItemsRequest = {
  userId: string
  ccId: string
}

export type CCRelatedItemsResponse = {
  requests_for_proposal: string[]
  organization_contract_categories: string[]
}

export type UserContractCategoriesColumnsFunc = (props: {
  role: string
  onChangeCommunityLevel?: ChangeCommunityLevelFunc
  setSelectedCC?: Dispatch<SetStateAction<UserContractCategory | null>>
  canManageContractCategories: boolean
  communityLevelCheckboxesVisible?: boolean
  communityLevelCheckboxesEditable?: boolean
  categoryAssignmentVisible: boolean
  userRole?: string
  onDeleteCC?: (id: string) => void
  hideActions?: boolean
  extendedViewModeOnly?: boolean
  simpleViewModeOnly?: boolean
}) => ColumnsType<UserContractCategory>

export type CCReassignmentOptionsRequest = {
  userId: string
  ccId: string
}

export type CCReassignmentOptionsResponse = {
  uuid: string
  first_name: string
  last_name: string
}

export type CCReassignRequestDataSetFormat = {
  led_by: string
  assignee: string
  can_be_edited?: boolean
}

export type CCReassignRequestDataFormat = {
  effective_date?: string
  assignee_set?: {
    rfp_assignee_set: CCReassignRequestDataSetFormat[]
    org_cc_assignee_set: CCReassignRequestDataSetFormat[]
  }
  assignee?: string
}

export type CCReassignRequest = {
  userId: string
  ccId: string
  data: CCReassignRequestDataFormat
}

export type TRemoveCCFromUserProfileRequest = {
  contract_categories: string[]
}

export type CCReassignmentRequest = CCReassignRequestDataFormat & {
  status: string
  uuid: string
}

export type CCAddRemoveToHospitalUserRequest = {
  contract_categories: string[]
}

export type VotingPanelMembershipCategory = {
  contract_category: string
  is_voting_panel_member: boolean
}

export type VotingPanelMembershipStatusRequestPayload = {
  contract_categories: VotingPanelMembershipCategory[]
}
